import React, { useState } from 'react'
import { Accordion, Icon, Message } from 'semantic-ui-react'
import { FormTitle } from '@commonComponents/FormTitle'
import ValueIndicator from './ValueIndicator'
import LineItemCharges from './LineItemCharges'
import MerchandiseDuty from './MerchandiseDuty'

const DutyAndTaxInformation = (props) => {
    const {
        invoiceId,
        merchandiseId,
        translate,
        ...rest
    } = props

    const [active, setActive] = useState(true)

    const toggle = () => setActive(!active)

    return (
        <Message style={{ padding: '0', borderRadius: '0' }}>
            <Accordion>
                <Accordion.Title
                    active={active}
                    onClick={toggle}
                    style={{ display: 'flex', justifyContent: 'center' }}
                >
                    <Icon name={active ? 'minus circle' : 'plus circle'} color='blue' />
                    <FormTitle title='DUTIES/TAX INFORMATION' />
                </Accordion.Title>
                <Accordion.Content active={active} style={{ padding: '0 1rem 1rem 1rem' }}>
                    <LineItemCharges invoiceId={invoiceId} merchandiseId={merchandiseId} enableFields={{custValue:true}} />
                    <ValueIndicator invoiceId={invoiceId} merchandiseId={merchandiseId} />
                    <div style={{marginTop:'12px'}}>
                        <MerchandiseDuty merchandiseId={merchandiseId} translate={translate} {...rest} />
                    </div>
                </Accordion.Content>
            </Accordion>
        </Message>
    )
}

export default DutyAndTaxInformation